module.exports = __webpack_public_path__ + "static/media/part-return-slide-2.2ca0146f.jpg";